import {
  defaultCountries,
  parseCountry,
  type ParsedCountry,
} from 'react-international-phone';

// Single source of truth for which countries the phone input supports.
// Add a country → add its ISO2 here (and its pattern in phone-regex.ts).
export const SUPPORTED_COUNTRY_ISO2 = ['ua', 'us'] as const;

export type SupportedCountryIso2 = (typeof SUPPORTED_COUNTRY_ISO2)[number];

export const isSupportedCountry = (iso2: string): iso2 is SupportedCountryIso2 =>
  SUPPORTED_COUNTRY_ISO2.some((code) => code === iso2);

// Raw country data to constrain `usePhoneInput` to supported countries only.
export const SUPPORTED_COUNTRY_DATA = defaultCountries.filter((data) =>
  isSupportedCountry(parseCountry(data).iso2),
);

// Parsed list (name, iso2, dialCode) for rendering the country dropdown.
export const SUPPORTED_COUNTRIES: ParsedCountry[] =
  SUPPORTED_COUNTRY_DATA.map(parseCountry);
